import React from 'react';
import './Modal.css';

const ThemeSelectionModal = ({ isOpen, onClose, onThemeSelect }) => {
  if (!isOpen) return null;

  const handleThemeSelect = (theme) => {
    onThemeSelect(theme);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content theme-selection-modal">
        <div className="modal-header">
          <h2>Choose Your Theme</h2>
        </div>
        
        <div className="theme-options">
          <div className="theme-option" onClick={() => handleThemeSelect('theme1')}>
            <div className="theme-icon">
              <img 
                src="/photos/nicoleLogo2.png" 
                alt="NicoleCodeGirl Logo" 
                className="theme-logo"
              />
            </div>
            <h3>Theme 1: NicoleCodeGirl</h3>
            <p>Personal photos of Nicole, her cats, and artwork</p>
            <div className="theme-preview">
              <span className="preview-text">Personal Collection</span>
            </div>
          </div>
          
          <div className="theme-option" onClick={() => handleThemeSelect('theme2')}>
            <div className="theme-icon">👥</div>
            <h3>Theme 2: Community</h3>
            <p>Photos submitted by players from the community</p>
            <div className="theme-preview">
              <span className="preview-text">Player Submissions</span>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <p className="theme-note">Choose a theme to start your memory game!</p>
        </div>
      </div>
    </div>
  );
};

export default ThemeSelectionModal;
